/**
 * Every piece of standing copy on the public site lives here so it can be edited
 * without touching a component. Nothing in this file asserts anything the studio
 * has not published elsewhere: no headcount, benefits, policies, testimonials or
 * compensation. Those belong in job records an admin writes, or in the
 * configuration block at the bottom, which needs an owner decision before launch.
 */

export const SITE = {
  companyName: 'Absurd Technologies',
  legalName: 'Absurd Technologies LLC',
  careersName: 'Careers',
  mainSiteUrl: 'https://tekabsurd.com',
  aboutUrl: 'https://tekabsurd.com/about',
  careersUrl: 'https://career.tekabsurd.com',
  location: 'New York, United States',
  defaultTitle: 'Careers — Absurd Technologies',
  defaultDescription:
    'Open roles at Absurd Technologies, an independent software studio in New York building custom web applications, workflow automation, and responsible AI integrations.',
} as const;

export const HERO = {
  eyebrow: 'New York · Independent software studio',
  heading: 'Build software that earns its place.',
  intro:
    'Join a small, senior team helping founders and operating teams replace fragile processes, launch useful products, and improve software people already depend on.',
  primaryCta: { label: 'View open roles', href: '#open-roles' },
  secondaryCta: { label: 'Visit the studio', href: SITE.mainSiteUrl },
} as const;

export const ABOUT_BLURB =
  'Absurd Technologies is a founder-led software studio in New York. We plan, design and engineer custom web applications, workflow automation, responsible AI integrations, and modernisation of software teams already rely on.';

export const EMPTY_ROLES = {
  heading: 'No open roles right now.',
  body: 'We post openings here when they exist, and we do not collect speculative applications in the meantime. Checking back occasionally is the reliable way to hear about the next one.',
} as const;

export const PRIVACY_CONFIG = {
  contactEmail: 'contact@tekabsurd.com',
  postalAddress: 'Absurd Technologies LLC, New York, United States',
  retentionPeriod: '12 months from the date you apply',
  lastUpdated: 'September 4, 2026',
} as const;
